import { message } from "antd";

import { ServiceUnavailableError, TooManyRequestsError } from "utilities/apiHandler";

import { BTButton } from "commonComponents/btWrappers/BTButton/BTButton";

import { useUsersMeRequestPasswordResetPostV2 } from "handlers/users/users";

type SendResetLinkAction = "sendResetLink";

interface IResetPasswordButtonProps {
    isSelf: boolean;
}

export const ResetPasswordButton = ({ isSelf }: IResetPasswordButtonProps) => {
    const { mutate, isLoading } = useUsersMeRequestPasswordResetPostV2({
        mutation: {
            onSuccess: () => {
                void message.success("Password reset link sent. Check your inbox.");
            },
            onError: (error) => {
                if (error instanceof TooManyRequestsError) {
                    void message.warning(
                        "A password reset link was recently sent. Please check your inbox, or try again in a few minutes.",
                    );
                } else if (error instanceof ServiceUnavailableError) {
                    const minutes = error.retryAfterSeconds
                        ? Math.ceil(error.retryAfterSeconds / 60)
                        : null;
                    void message.error(
                        minutes
                            ? `Unable to send password reset link. Please try again in ${minutes} ${
                                  minutes === 1 ? "minute" : "minutes"
                              }.`
                            : "Unable to send password reset link. Please try again later.",
                    );
                } else {
                    void message.error("Unable to send password reset link. Please try again.");
                }
            },
        },
    });

    // Defense-in-depth: callers also gate externally to suppress the surrounding layout cell.
    // Admin-reset-others will be a separate component — do not relax this guard here.
    if (!isSelf) {
        return null;
    }

    return (
        <BTButton<SendResetLinkAction>
            type="secondary"
            data-testid="btnResetPassword"
            onClick={() => mutate()}
            actionBeingPerformed={isLoading ? "sendResetLink" : undefined}
            loadingAction="sendResetLink"
        >
            Reset password
        </BTButton>
    );
};
